module.exports = __webpack_public_path__ + "img/Mushrooms.02bfc8d7.png";